import { SidebarLayout } from '@/core/layouts/sidebar-layout';
import { gmnRoutes } from '@/core/router';

export function GmnLayout() {
  return <SidebarLayout routes={gmnRoutes} mainClassName="flex-1 overflow-y-auto" />;
}
